import api from "../../api/index";
import config from "../../../static/config.json";
import qs from "qs";

const state = {};
const mutations = {};
const getters = {};
const actions = {
  // 注册
  addReg({ rootState, commit }, opt) {
    return new Promise((resolve, reject) => {
      api
        .post(`${config.https.api}/api/v3/mmeberv3/reg/visitor/account/email`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          resolve(false);
          console.log(err);
        });
    });
  },
  // 登录
  login({ rootState, commit }, opt) {
    return new Promise((resolve, reject) => {
      api
        .post(`${config.https.auth}/connect/token`, qs.stringify(opt), rootState.formHeaders)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          resolve(false);
          console.log(err);
        });
    });
  },
  graphqlPostByToken({ rootState }, opt) {
    // 获取主办
    let header = {
      "content-Type": "application/json; charset=utf-8;",
      headers: {
        Authorization: "Bearer " + rootState.access_token,
      },
    };
    return new Promise((resolve, reject) => {
      api
        .post(`${config.https.api}/graphql`, opt, header)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          } else {
            resolve(null);
          }
        })
        .catch((err) => {
          resolve(null);
          console.log(err);
        });
    });
  },
  //mice cad 阿波罗接口（展商秀接口）
  graphqlPostByZXS({ rootState }, opt) {
    // 获取主办
    let headers = {
      "content-Type": "application/json; charset=utf-8;",
      headers: {
        "lang-version": "en",
      },
    };
    let name = "";
    if (opt.queryName) {
      name = opt.queryName + "";
      delete opt.queryName;
    }
    return new Promise((resolve, reject) => {
      api
        .post(`${config.https.api}/graphql${name ? "?queryName=" + name : ""}`, opt, headers)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          } else {
            resolve(null);
          }
        })
        .catch((err) => {
          resolve(null);
          console.log(err);
        });
    });
  },
  CNgraphqlPostByZXS({ rootState }, opt) {
    // 获取主办
    let headers = {
      "content-Type": "application/json; charset=utf-8;",
      "lang-version": "en",
    };
    // console.log(header,'header')
    return new Promise((resolve, reject) => {
      api
        .post(`${config.https.api}/graphql`, opt, headers)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          } else {
            resolve(null);
          }
        })
        .catch((err) => {
          resolve(null);
          console.log(err);
        });
    });
  },
  checkEmail({ rootState, commit }, email) {
    // 检查邮箱是否存在
    return new Promise((resolve, reject) => {
      api
        .get(`${config.https.auth}/api/v1/account/has/email?email=${email}`)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          resolve(false);
          console.log(err);
        });
    });
  },
  changPSW({ rootState, commit }, body) {
    // 修改密码
    return new Promise((resolve, reject) => {
      api
        .put(`${config.https.auth}/api/v1/account/update/password/email`, body)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          resolve(false);
          console.log(err);
        });
    });
  },
};
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
